import './Batches.css';

import {
    Snack, Snackbar, Text
} from "@nike/eds";
import { useSelector, useDispatch } from 'react-redux';
import { selectNotification, toggleNotification, findExceptions, selectExceptions, selectExceptionsLoaded } from '../shared/store/reducers/OverviewReducer';
import { StoreDispatch } from '../shared/store/Store';
import { Notification, Exception } from '../shared/Types';
import { ExceptionsDashboard } from '../components/exceptions_dashboard/ExceptionsDashboard';
import { useEffect } from 'react';
import { ExceptionsCounter } from '../components/exceptions_counter/ExceptionsCounter';
import { ExceptionsActionContainer } from '../components/exceptions_action_container/ExceptionsActionContainer';

export function Exceptions() {
    const dispatch: StoreDispatch = useDispatch();

    const exceptions = useSelector(selectExceptions) as Exception[];
    const notification: Notification = useSelector(selectNotification);
    const exceptionsLoaded: boolean = useSelector(selectExceptionsLoaded);

    useEffect(() => {
        if (!exceptionsLoaded) {
            dispatch(findExceptions());
        }
    }, [dispatch, exceptionsLoaded]);

    const onClickDismissSnack = () => {
        dispatch(toggleNotification(null));
    }

    return (
        <div id="main-container">
            <span className="button-container">
                <Text font={"title-3"} as={"h3"} className={"eds-spacing--my-24"} >Exceptions</Text>
                <ExceptionsCounter exceptionsLength={exceptions.length} />
            </span>
            <Snackbar>
                {notification && (
                    <Snack id="snack" status={notification.status} onDismiss={onClickDismissSnack} autoDismissDuration={15000}>
                        <p className="eds-type--body-2">{notification.message.replace(/^.+?(:) /, '')}</p>
                    </Snack>
                )}
            </Snackbar>
                <>
                    <ExceptionsActionContainer/>
                    <ExceptionsDashboard/>
                </>
        </div>
    )
}